import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { faChevronLeft, faChevronCircleLeft, faChevronRight, faChevronCircleRight } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.less'],
    standalone: false
})
export class PaginationComponent implements OnInit, OnChanges {

  faChevronRight = faChevronRight;
  faChevronLeft = faChevronLeft;
  faChevronCircleRight = faChevronCircleRight;
  faChevronCircleLeft = faChevronCircleLeft;

  constructor() { }
  ngOnChanges(changes: SimpleChanges): void {
    setTimeout(() => {
      if(changes?.pags) {
        this.pags = changes.pags.currentValue;
      }
      if(changes?.total) {
        this.total = changes.total.currentValue;
      }
      if(changes?.current) {
        this.current = changes.current.currentValue;
      }
      if(changes?.display) {
        this.display = changes.display.currentValue;
      }
      this.setPag();
      this.setDisplay();
    },100);
  }

  arr: number[] = [];

  @Input() current: number = 1;
  @Input() pags: number = 1;
  @Input() total: any[] = [];
  @Input() display: any[] = [];
  @Input() maxP: number = 5;
  @Output() currentChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() pagsChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() totalChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() displayChange: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {
    console.log(this.pags);
  }

  setPag() {
    this.arr = [];
    var ctrl = 0;
    var fix = this.pags - this.current == 0 ? this.pags - this.current + 2 : (this.pags - this.current == 1 ? this.pags - this.current : 0);
    for(var i = this.current - 2 - fix > 0 ? this.current - 2 - fix : 1; i <= this.pags && ctrl < this.maxP; i++) {
      this.arr.push(i);
      ctrl++;
    }
  }

  setFirst() {
    this.current = 1;
    this.currentChange.emit(this.current);
    this.setDisplay();
  }

  setLast() {
    this.current = this.pags;
    this.currentChange.emit(this.current);
    this.setDisplay();
  }

  setPlus() {
    this.current++;
    if(this.current > this.pags)
      this.current = this.pags;
    this.currentChange.emit(this.current);
    this.setDisplay();
  }

  setMinus() {
    this.current--;
    if(this.current < 1)
      this.current = 1;
    this.currentChange.emit(this.current);
    this.setDisplay();
  }

  setDisplay() {
    if(this.total.length < 8) {
      this.display = this.total;
    }else{
      this.display = this.total.slice((this.current-1)*8,this.current*8);
    }
    this.displayChange.emit(this.display);
  }

  setP(it: number) {
    this.current = it;
    this.currentChange.emit(this.current);
    this.setDisplay();
  }

}
